const initialState = {
    isOpen: false,
    isActive: false,
    uniqueCode: '', // marboot be consignment
    product: {},
    comment: '',
    disableBtn: true,
};
const modalProductRating = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_PRODUCT_RATING':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalProductRating;
